import { render, staticRenderFns } from "./QuickscanStep1.vue?vue&type=template&id=00a1957a"
import script from "./QuickscanStep1.vue?vue&type=script&lang=js"
export * from "./QuickscanStep1.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports